module.exports = __webpack_public_path__ + "static/img/holiday.969c2bf4.svg";